export enum CashType {
  Coin,
  Banknote
}
